import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const hash = window.location.hash.replace("#", "")
    const validTabs = this.tabTargets.map(t => t.dataset.tab)
    const initial = validTabs.includes(hash) ? hash : validTabs[0]
    this.showTab(initial)
  }

  select(event) {
    const tab = event.currentTarget.dataset.tab
    if (tab) {
      this.showTab(tab)
      history.replaceState(null, "", `#${tab}`)
    }
  }

  showTab(name) {
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.id !== name)
    })

    this.tabTargets.forEach(tab => {
      const active = tab.dataset.tab === name
      tab.classList.toggle("bg-yellow-50", active)
      tab.classList.toggle("text-yellow-700", active)
      tab.classList.toggle("font-semibold", active)
      tab.classList.toggle("bg-gray-50", !active)
      tab.classList.toggle("text-gray-600", !active)
    })
  }
}
